import axios from "../axios.js";

// Refresh token lives in an HttpOnly cookie set by the backend; it's never
// touched by JS. axios is configured with withCredentials so the cookie
// is sent automatically on every /login/* call.

export const loginRequest = async (username, password) => {
    return axios.post("/login/", { username, password });
};

export const refreshRequest = async () => {
    return axios.post("/login/refresh", {});
};

export const changePasswordRequest = async (currentPassword, newPassword) => {
    return axios.put("/login/change-password", {
        currentPassword,
        newPassword,
    });
};

export const logoutRequest = async () => {
    try {
        await axios.post("/login/logout", {});
    } catch {
        // best-effort — even if the request fails, the caller clears state locally
    }
};

export const updateSessionPreferenceRequest = async (sessionSecs) => {
    return axios.put("/login/session-preference", { sessionSecs });
};

// Per-user: auto-open the sales-order quick colour dialog (users.so_quick_colour_entry)
export const updateQuickColourPreferenceRequest = async (enabled) => {
    return axios.put("/login/quick-colour-preference", { enabled });
};

// Per-user default location: { defaultLocationId, locations } — the locations
// this user is allowed to choose (assigned ones; all when unscoped)
export const getDefaultLocationRequest = async (signal) => {
    return axios.get("/login/default-location", { signal });
};

// Per-user: the location pages pre-select (users.default_location_id); null clears it
export const updateDefaultLocationRequest = async (locationId) => {
    return axios.put("/login/default-location", { locationId });
};

export const toggleSaleDiscountRequest = async (enabled) => {
    return axios.put("/login/sale-discount-toggle", { enabled });
};

export const toggleYarnCartonModeRequest = async (enabled) => {
    return axios.put("/login/yarn-carton-toggle", { enabled });
};

export const toggleWarpColourFilterRequest = async (enabled) => {
    return axios.put("/login/warp-colour-filter-toggle", { enabled });
};

export const toggleQrHideDealerEncodedPriceRequest = async (enabled) => {
    return axios.put("/login/qr-hide-dealer-price-toggle", { enabled });
};

// Automatic WhatsApp (admin): { autoInvoice, autoLr, autoReminders, adminNumber } — 12 AM
// invoice job, LR-approved message, the daily payment-reminder job, and the number
// that gets the "no number saved" summary.
export const toggleWhatsAppAutoRequest = async ({ autoInvoice, autoLr, autoReminders, adminNumber }) => {
    return axios.put("/login/whatsapp-auto-toggle", { autoInvoice, autoLr, autoReminders, adminNumber });
};

// Dashboard firm/unit scope (admin): which firms/units the Dashboard counts. Empty = all.
export const getDashboardScopeRequest = async (signal) => axios.get("/login/dashboard-scope", { signal });
export const saveDashboardScopeRequest = async ({ firmIds, unitIds }) =>
    axios.put("/login/dashboard-scope", { firmIds, unitIds });
